function TwoDecimalNumberFilter() {

  return function(input) {
    if(input && input != "") {
      return Number(Math.abs(input)).toFixed(2);
    }
    return input;
  };

}

export default {
  name: 'TwoDecimalNumberFilter',
  fn: TwoDecimalNumberFilter
};
